import { DividerProps } from '@app/types'
import { Divider as AntDivider } from 'antd'

export const Divider: React.FC<DividerProps> = (props) => <AntDivider {...props} />
